export { MainPage as default } from 'src/components/Main/MainPage'
